import { h, compile } from 'vue';
// import { createApp } from 'vue/dist/vue.runtime.esm-bundler';
export default defineNuxtPlugin(nuxtApp => {
  const { $apiMethods, $helpers, $methods } = useNuxtApp()
  const tfGetLanguage = () => {
    try {
      const dataAll = useDataAll();
      return dataAll.getLanguage() || 'nl'; // Fallback naar 'nl'
    } catch (error) {
      console.error("Error in tfGetLanguage:", error);
      return 'nl'; // Default language
    }
  };  
  
  const tfGetLabel = () => {
    try {
      return $helpers.getLabelId() || '';
    } catch (error) {
      console.error("Error in tfGetLabel:", error);
      return ''; // empty string
    }
  };
  // the plugin nuxt-link.js is used to prevent NuxtLink to be nuxtlink after compilation
  nuxtApp.vueApp.component('VuetifyRender', {
    props: ['html'],
    render() {

      if (typeof (this.html) != "undefined" && this.html !== null) {
        try {
           // remove excesive whitespace en newlines
          let cleanedHtml = this.html.replace(/\s+/g, ' ').trim();

          // Compile en render
          const compiledComponent = compile(cleanedHtml)
          
          return h(compiledComponent, { 
            $emit: this.$emit,
            tfGetLanguage: tfGetLanguage,
            tfGetLabel: tfGetLabel,  
          });
        } catch (error) {
            console.error("Error compiling HTML on client:", error);
            return h('div', { style: { color: 'red' } }, "Error rendering content.");
        }
      } else {
        return h("", { $emit: this.$emit });
      }
    }
  })
})

